import type {ValueVisualDescriptorList} from '@github-ui/filter-core'
import {GitHubAvatar} from '@github-ui/github-avatar'
import type {Icon} from '@primer/octicons-react'

import {resolveValueVisualDescriptor} from './value-visuals'
import styles from './ValueIcon.module.css'

export interface ValueIconProps {
  visuals?: ValueVisualDescriptorList | null
  providerIcon?: Icon
}

export const ValueIcon = ({visuals, providerIcon}: ValueIconProps) => {
  const visual = resolveValueVisualDescriptor(visuals, providerIcon)
  if (!visual) return null

  if (visual.kind === 'avatar') {
    return (
      <GitHubAvatar
        src={visual.url}
        alt={visual.alt}
        square={visual.square ?? false}
        className={styles.GitHubAvatar_0}
      />
    )
  }

  if (visual.kind === 'color-swatch') {
    return <div style={{backgroundColor: visual.color}} className={styles.Box_0} />
  }

  const cssIconColor = visual.color ? `${visual.color} !important` : 'currentcolor'
  const VisualIcon = visual.icon
  return <VisualIcon fill={cssIconColor} />
}
